import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import logo from '../assets/2s-pay.png';

export default function SplashScreen({ onComplete }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => onComplete(), 500);
          return 100;
        }
        return prev + Math.random() * 5; // ≈10 s total
      });
    }, 150);
    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="fixed inset-0 z-50 bg-gradient-to-br from-blue-600 via-blue-500 to-indigo-600 flex items-center justify-center"
      >
        <div className="text-center text-white">
          {/* Logo agrandi */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-12"
          >
            <div className="w-52 h-52 mx-auto bg-white rounded-3xl flex items-center justify-center shadow-2xl">
              <img
                src={logo}
                alt="2S Group Logo"
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </motion.div>

          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-4xl font-bold mb-3"
          >
            2S-PAY
          </motion.h1>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="text-lg opacity-90 mb-12"
          >
            Plateforme immobilière
          </motion.p>

          <motion.div
            initial={{ width: 0, opacity: 0 }}
            animate={{ width: '100%', opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="w-72 h-2 bg-white/20 rounded-full mx-auto overflow-hidden"
          >
            <motion.div
              className="h-full bg-white rounded-full"
              style={{ width: `${progress}%` }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 1 }}
            className="mt-4 text-sm opacity-80"
          >
            {progress < 30 && 'Initialisation...'}
            {progress >= 30 && progress < 60 && 'Chargement des données...'}
            {progress >= 60 && progress < 90 && "Préparation de l'interface..."}
            {progress >= 90 && 'Presque prêt...'}
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 1.2 }}
            className="mt-6"
          >
            <div className="w-6 h-6 mx-auto border-2 border-white/30 border-t-white rounded-full animate-spin" />
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.4 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-center text-white/60 text-sm"
        >
          <p>Version 1.0.0</p>
          <p className="mt-1">© 2025 2S-PAY. Tous droits réservés.</p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
